import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { RequestTypes } from '@ubeya/shared/hooks/generic/useRequestsTypes';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Type = styled.div`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1.38;
  font-size: 14px;
  cursor: pointer;
`;

const DetailsRenderer = ({
  rowData,
  columnData: { mappedLabels, mappedLocations, setSelectedEmployee, setSelectedShiftSwap }
}) => {
  const { t, accountId } = useContext(ConfigContext);

  const onClickGeneralAvailability = useCallback(() => setSelectedEmployee({ id: rowData?.employeeId }), [
    rowData?.employeeId,
    setSelectedEmployee
  ]);

  const onClickShiftSwap = useCallback(() => setSelectedShiftSwap(rowData), [rowData, setSelectedShiftSwap]);

  const openEventInNewTab = useCallback(() => {
    if (!rowData.data.projectBranchId || !rowData.data.projectId) {
      return;
    }

    window
      .open(
        `${accountId}/scheduling/branch/${rowData.data.projectBranchId}/project/${rowData.data.projectId}`,
        '_blank'
      )
      .focus();
  }, [accountId, rowData.data.projectBranchId, rowData.data.projectId]);

  const { onClick, title } =
    (() => {
      switch (rowData?.typeId) {
        case RequestTypes.ABSENCE:
          return { onClick: undefined, title: '' };

        case RequestTypes.GENERAL_AVAILABILITY:
          return { onClick: onClickGeneralAvailability, title: t('availability') };

        case RequestTypes.RELEASE_SHIFT: {
          const { projectLabelId, projectName, projectLocationId } = rowData?.data || {};

          const releaseTitle =
            projectName || projectLabelId
              ? mappedLabels?.[projectLabelId]?.title
              : projectLocationId
              ? mappedLocations?.[projectLocationId]?.name
              : t('release-shift');

          return { onClick: openEventInNewTab, title: releaseTitle };
        }
        case RequestTypes.SWAP_SHIFT:
          return { onClick: onClickShiftSwap, title: t('shift-swap') };

        case RequestTypes.LEAVE_REQUEST: {
          const { projectId, projectBranchId, projectName } = rowData?.data || {};
          if (!projectId || !projectBranchId) {
            return { onClick: undefined, title: '' };
          }
          return { onClick: openEventInNewTab, title: projectName || t('viewEvent') };
        }

        default:
          break;
      }
    })() || {};

  return <Type onClick={onClick}>{title}</Type>;
};

export default DetailsRenderer;
